<template>
  <div class="row text-center">
    <div class="col-xs-12 col-sm-12 col-md-10 col-lg-10">
      <Pagination
        v-if="total"
        id="paginador"
        v-model="pagina"
        :total-page="total"
        name="paginador"
        boundary-links
        @change="paginaAlterada"
      />
    </div>
    <div
      class="hidden-xs hidden-sm col-xs-2 col-sm-2 col-md-2 col-lg-2"
      style="margin: 17px 0"
    >
      <ToolbarModoResultado
        :modo-resultado="modoResultado"
        @modoAlterado="modoAlterado"
      />
    </div>
  </div>
</template>

<script>
import ToolbarModoResultado from '@/componentes/ToolbarModoResultado'

export default {
  name: 'BlocoPaginadorPesquisa',
  components: { ToolbarModoResultado },
  props: {
    total: {
      type: Number,
      default: 0,
    },
    modoResultado: {
      type: String,
      default: 'C',
    },
  },
  data() {
    return {
      pagina: 1,
    }
  },
  methods: {
    paginaAlterada(pagina) {
      this.$emit('paginaAlterada', pagina)
    },
    modoAlterado(modo) {
      this.$emit('modoAlterado', modo)
    },
  },
}
</script>
